// Servizio per gestire Supabase tramite Netlify Functions
// Questo evita i problemi CORS utilizzando le funzioni serverless

export interface Lead {
  id: string
  user_id: string
  nome: string
  telefono: string
  email: string
  prezzo: number
  marca: string
  modello: string
  anno: string
  km: number
  targa: string
  localizzazione: string
  browser_info: any
  foto_veicolo: string[]
  immagini_veicolo: string[]
  acquistato: boolean
  created_at: string
}

// Funzioni per gestire i Lead tramite Netlify Functions
export const netlifyLeadService = {
  // Crea un nuovo lead e invia email (funzione unificata)
  createLead: async (leadData: Omit<Lead, 'id' | 'created_at' | 'acquistato'>) => {
    try {
      const response = await fetch('/.netlify/functions/lead-email-handler/create-lead', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(leadData),
      });

      const result = await response.json();

      if (!response.ok) {
        console.error('Errore nella creazione del lead:', result);
        return { data: null, error: result };
      }

      return { data: result.lead, error: null };
    } catch (err) {
      console.error('Errore nella creazione del lead:', err);
      return { data: null, error: err };
    }
  },

  // Ottieni tutti i lead per un utente
  getLeadsByUser: async (userId: string) => {
    try {
      const response = await fetch(`/.netlify/functions/lead-email-handler/get-leads?user_id=${userId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const result = await response.json();

      if (!response.ok) {
        console.error('Errore nel recupero dei lead:', result);
        return { data: [], error: result };
      }

      return { data: result.data, error: null };
    } catch (err) {
      console.error('Errore nel recupero dei lead:', err);
      return { data: [], error: err };
    }
  },

  // Aggiorna lo stato di acquisto di un lead
  updateLeadPurchaseStatus: async (leadId: string, acquistato: boolean) => {
    try {
      const response = await fetch('/.netlify/functions/lead-email-handler/update-lead', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ lead_id: leadId, acquistato }),
      });

      const result = await response.json();

      if (!response.ok) {
        console.error('Errore nell\'aggiornamento del lead:', result);
        return { data: null, error: result };
      }

      return { data: result.data, error: null };
    } catch (err) {
      console.error('Errore nell\'aggiornamento del lead:', err);
      return { data: null, error: err };
    }
  }
}

// Funzione di test per verificare la connessione
export const testSupabaseConnection = async () => {
  try {
    const response = await fetch('/.netlify/functions/lead-email-handler/get-leads?user_id=test', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const result = await response.json();
    
    if (response.ok) {
      console.log('Connessione Supabase tramite Netlify Functions: OK');
      return { success: true, message: 'Connessione OK' };
    } else {
      console.warn('Connessione Supabase tramite Netlify Functions: Errore', result);
      return { success: false, message: result.error || 'Errore di connessione' };
    }
  } catch (err) {
    console.error('Errore di connessione Supabase:', err);
    return { success: false, message: 'Errore di rete' };
  }
}
